export const STYLE_ELEMENT_OPTIONS = {
	default: 'css',
	presets: 'presets',
	compPaths: 'paths-container',
}

export const NON_BUILDER_LEGACY_COMPONENT_TYPES = [
	'TPAWidget',
	'TPAGluedWidget',
	'TPASection',
	'TPAMultiSection',
	'tpaWidgetNative',
	'CustomElementComponent',
] as const

export const applyStyle = ({ id, css }: { id: string; css: string }) => {
	// dom-id-usage-check-ignore-next-line -- <style> tag resource id; style tags never carry an identity class
	const existingStyleElement = window.document.getElementById(id)
	if (!existingStyleElement) {
		const styleElement = window.document.createElement('style')
		// dom-id-usage-check-ignore-next-line -- <style> tag resource id, not a component id
		styleElement.id = id
		styleElement.textContent = css
		document.head.appendChild(styleElement)
	} else {
		existingStyleElement.textContent = css
	}
}

const compPathsStyleElementIdSuffix = `--${STYLE_ELEMENT_OPTIONS.compPaths}`

/**
 * Removes comp-path style tags (ids `${compId}--${STYLE_ELEMENT_OPTIONS.compPaths}`) whose compId
 * is not in keep-list. Used on editor page navigation alongside builder CSS cleanup.
 */
export const clearCompPathsStyleElementsExceptCompIds = (
	compIdsToKeep: ReadonlySet<string> | readonly string[]
): void => {
	const keep = compIdsToKeep instanceof Set ? compIdsToKeep : new Set(compIdsToKeep)

	// dom-id-usage-check-ignore-next-line -- enumerates every <style> tag by presence of an id attribute; no class equivalent exists
	document.querySelectorAll('style[id]').forEach((el) => {
		const { id } = el
		if (!id.endsWith(compPathsStyleElementIdSuffix)) {
			return
		}
		const compId = id.slice(0, -compPathsStyleElementIdSuffix.length)
		if (!keep.has(compId)) {
			el.remove()
		}
	})
}
